module.exports = __webpack_public_path__ + "img/id-correct-backside.ab5ada8d.png";